import React, { Component } from "react";

class Weather extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: {},
      isLoaded: false,
    };
  }
  componentDidMount() {
    fetch("https://mm214.com/demo.php")
      .then((res) => res.json())
      .then((json) => {
        console.log("json:", json);
        this.setState({
          isLoaded: true,
          items: json,
        });
      });
    console.log(this.state);
  }
  render() {
    let { isLoaded, items } = this.state;

    if (!isLoaded) {
      return <div>Loading...</div>;
    } else {
      return (
        <div className="container">
          <div className="logo">
            <img
              src={process.env.PUBLIC_URL + "/logo.png"}
              width="150"
              alt="logo"
            />
            <h1 className="header">Welcome to the Weather Center</h1>
          </div>
          <div className="weather">
            <br></br>
            <h3>Today's weather for {this.state.items.name}</h3>
            <h3></h3>
            <ul>
              <li>In the Sky: {this.state.items.weather[0].description}</li>
              <li>
                Temperature:{" "}
                {Math.round((this.state.items.main.temp - 273.15) * 1.8 + 32)}{" "}
                &#8457;
              </li>
              <li>
                Feels like:{" "}
                {parseInt(
                  (this.state.items.main.feels_like - 273.15) * 1.8 + 32
                )}{" "}
                &#8457;
              </li>
              <li>Wind Speed: {this.state.items.wind.speed}mph</li>
            </ul>
          </div>
        </div>
      );
    }
  }
}
export default Weather;
